/**
 * useYetki — granular yetki kontrolü.
 *
 * Kullanım:
 *   const canEdit = useYetki('maas.duzenle')
 *   const canAny = useYetki(['avans.onayla', 'avans.ode_isaretle'])  // herhangi biri yeterli
 *
 * Kurallar:
 *   - BOSS her zaman true (bypass)
 *   - Personel rolünde olup yoneticiMi:true olanlar yoneticiYetkileri'ne göre değerlendirilir
 *   - Diğerleri false
 */

import { useAuth } from '@/contexts/AuthContext'
import type { YetkiId } from '@/lib/yetkiler'

export function useYetki(yetki: YetkiId | YetkiId[]): boolean {
  const { kullanici } = useAuth()
  if (!kullanici) return false
  if (kullanici.rol === 'boss') return true
  if (kullanici.rol !== 'personel') return false
  if (!kullanici.yoneticiMi) return false

  const sahip = (kullanici.yoneticiYetkileri ?? []) as YetkiId[]
  if (Array.isArray(yetki)) {
    return yetki.some(y => sahip.includes(y))
  }
  return sahip.includes(yetki)
}

/** Tüm verilen yetkilere sahip mi? */
export function useTumYetkiler(yetkiler: YetkiId[]): boolean {
  const { kullanici } = useAuth()
  if (!kullanici) return false
  if (kullanici.rol === 'boss') return true
  if (kullanici.rol !== 'personel' || !kullanici.yoneticiMi) return false
  const sahip = (kullanici.yoneticiYetkileri ?? []) as YetkiId[]
  return yetkiler.every(y => sahip.includes(y))
}

/** Kullanıcı yönetici paneline girebilir mi? (BOSS veya en az 1 yetkili personel) */
export function useYoneticiErisimi(): boolean {
  const { kullanici } = useAuth()
  if (!kullanici) return false
  if (kullanici.rol === 'boss') return true
  if (kullanici.rol !== 'personel') return false
  if (!kullanici.yoneticiMi) return false
  return (kullanici.yoneticiYetkileri ?? []).length > 0
}
